function Broadcast(props) {
  return <h1>Lịch phát sóng</h1>;
}

export default Broadcast;
